import React from 'react'
import { css } from 'emotion'
import {Col, Tab, Tabs, Alert, Button} from 'react-bootstrap'
import logo from 'app/universal/assets/images/logo-moulin-traiteur-companion.svg'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './styles';
import PhoneLoginForm from './PhoneLoginForm';
import {Helmet} from "react-helmet";

const LoginB2C = (props) => {

  const {
    handleSubmit,
    isLoading
  } = props

  const deployVer = process.env.REACT_APP_VERSION;
  const curVersion = localStorage.getItem('version');

  return (
    <>
      <Helmet>
        <title>Connexion - Le Moulin Charrette</title>
      </Helmet>
      {curVersion === 'undefined' || curVersion === null || curVersion !== deployVer && <Alert variant="warning" className="mb-0 text-center">Nouvelle version disponible<br/><Button onClick={ () => window.location.reload()}>Mettre à jour</Button></Alert>}
      <div className={css(styles.login)}>
        <Col xs={12} className={css(styles.block)}>
          <div className={css(styles.logoImg)}>
            <img className={css(styles.img)} src={logo} alt="Le Moulin - Commande en ligne" />
          </div>
          <Tabs
            defaultActiveKey="livreur"
            id="connection-tabs-b2c"
            className="mb-3"
            fill
          >
            {/* Livreur B2C : code SMS (accès selon son périmètre et ses périodes, gérés au BO) */}
            <Tab eventKey="livreur" title="Livreur">
              <PhoneLoginForm handleSubmit={handleSubmit} isLoading={isLoading}/>
            </Tab>
            <Tab eventKey="charrette" title="Identifiant">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className={css(styles.label)}>Identifiant*</label>
                  <input type="text" name="username" className={css(styles.input)} required/>
                </div>
                <div className="form-group">
                  <label className={css(styles.label)}>Mot de passe*</label>
                  <input type="password" name="password" className={css(styles.input)} required/>
                </div>
                
                <button type="submit" className={css(styles.button)} disabled={isLoading}>{isLoading ? <FontAwesomeIcon icon={faSpinner} pulse/> : "Se connecter"}</button>
              </form>
            </Tab>
          </Tabs>
        </Col>
      </div>
    </>

  )

}

export default LoginB2C
